export const JSON_ONE5NW = {

    
        "txn_response":
        {
        "ag_id":"paygate",
        "me_id":"2022052400 04",
        "order_no":"78679",
        "amount":"49.00",
        "country":"ARE",
        "currency":"AED",
        "txn_date":"01-07-2021",
        "txn_time":"01:03:55",
        "ag_ref":"1010320713490375847",
        "pg_ref":"PG_1010320713490375847",
        "status":"Successful",
        "res_code":"00000",
        "res_message":"Successful",
        "bank_response":""
        },
        "pg_details":
        {
        "pg_id":"63",
        "paymode":"CC",
        "emi_months":"0"
        },
        "fraud_details ":{},
        "other_detail s":
        {
        "udf_1":"",
        "udf_2":"",
        "udf_3":"",
        "udf_4":"",
        "udf_5":""
        },
        "card_no":"401613XXXXXX3143"
        


};